export enum MenuActionType {
    NavigateToUrl = 'NavigateToUrl',
    WindowOpenNew = 'WindowOpenNew',
    WindowOpenSelf = 'WindowOpenSelf',
    OpenModal = 'OpenModal',
    Logout = 'Logout'
}
